import React, { PropsWithChildren } from 'react';
import { withTheme } from '@material-ui/core/styles';

import './style.css';

const FocusPanel: React.FC<PropsWithChildren<{ theme: any; testId?: string }>> = ({
  children,
  theme,
  testId,
}) => (
  <main
    className="focus-panel"
    style={{ backgroundColor: theme.palette.background.light, color: theme.palette.text.primary }}
    data-testid={testId}
  >
    {children}
  </main>
);

const Themed = withTheme(FocusPanel);

export { Themed as FocusPanel };
